<app-links-item [color]="color" [icon]="icon" [labels]="server.labels" [uid]="server.uid">
  <div app-links-item-content-description>
    <div class="font-extra-small ng-star-inserted">{{ server.url }}</div>
  </div>
  <div app-links-item-content-option>
    <app-links-item-option class="d-block mx-1" [symbol]="'check'" [selected]="isSelected" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
</app-links-item>